module.exports = __webpack_public_path__ + "static/1351843740.2a1e7bf3.jpg";